import { render, staticRenderFns } from "./NewCreatedFileScroll.vue?vue&type=template&id=6bfe6b6a&scoped=true"
import script from "./NewCreatedFileScroll.vue?vue&type=script&lang=js"
export * from "./NewCreatedFileScroll.vue?vue&type=script&lang=js"
import style0 from "./NewCreatedFileScroll.vue?vue&type=style&index=0&id=6bfe6b6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfe6b6a",
  null
  
)

export default component.exports